
// import axios from 'axios'

const state = {
  ListaSzafy: {},
  ListaAkcesoria: {},
  ListaAkumulatory: {},
  ListaZasilacze: {},
  ListaListwyD: {},
  ListaListwyZ: {},
  ListaMaterialy: {}
}

const getters = {
  ListaSzafy: state => state.ListaSzafy,
  ListaAkcesoria: state => state.ListaAkcesoria,
  ListaAkumulatory: state => state.ListaAkumulatory,
  ListaZasilacze: state => state.ListaZasilacze,
  ListaListwyD: state => state.ListaListwyD,
  ListaListwyZ: state => state.ListaListwyZ,
  ListaMaterialy: state => state.ListaMaterialy
}

const mutations = {
  SET_LIST_SZAFY (state, payload) {
    state.ListaSzafy = payload
  },
  SET_LIST_AKCESORIA (state, payload) {
    state.ListaAkcesoria = payload
  },
  SET_LIST_AKUMULATORY (state, payload) {
    state.ListaAkumulatory = payload
  },
  SET_LIST_ZASILACZE (state, payload) {
    state.ListaZasilacze = payload
  },
  SET_LIST_LISTWY_D (state, payload) {
    state.ListaListwyD = payload
  },
  SET_LIST_LISTWY_Z (state, payload) {
    state.ListaListwyZ = payload
  },
  SET_LIST_MATERIALY (state, payload) {
    state.ListaMaterialy = payload
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/products.js